// Interfaces
import { InputInterface } from '../../../../../interfaces/Input';

const TextAreaInput = (props: InputInterface) => {
  return <textarea 
    name={props.name}
    placeholder={props.placeholder as string}
    className='form-input'
    onChange={input => props.onChange(input.target.value)}
    value={props.value}
  />;
}

export default TextAreaInput